<script>
import {BrandsPath, GravyPath} from "@/path";
import axios from "axios";
import Swal from "sweetalert2";
    export default {
        props : ['gravies','mainitem','maingravy'],
        data(){
            return {
                current_page : 1,
                fields : ['main_item','modifier','usage','brand','actions'],
                baseUrl : process.env.VUE_APP_API_BACKEND_URL,
            }
        },
        computed : {
            GravyPath() {
              return GravyPath
            },
            BrandsPath(){
                return BrandsPath
            }
        },
        methods : {
            async deleteGravyItem(v){
                try{
                    let res = await axios.delete(this.baseUrl + GravyPath.DELETE_GRAVY_ITEMS,{
                    params : {
                        id : v.item.id
                    }
                    });
                    if(res.data.status){
                        Swal.fire("success",'','success');                    
                        delete this.gravies[v.index];
                    }
                }catch (e){
                    console.log(e);
                }
            }
        }
    }
</script>

<template>
    <div>
        <div>
      <div class="table-responsive mb-0">
        <b-table
            :key="gravies.key"
            :items="gravies"
            :fields="fields"
            :per-page="10"
            responsive="sm"            
            :current-page="current_page"
        >          
          <template v-slot:cell(usage)="row">
            {{row.item.gm_usage}} {{ maingravy.units }}
          </template>          
          <template v-slot:cell(modifier)="row">            
            {{row.item.option != null ? row.item.option.title : ''}}
          </template>
          <template v-slot:cell(main_item)>
            {{ mainitem }}
          </template>
          <template v-slot:cell(brand)="row">
            {{row.item.brand != null ? row.item.brand.name : ''}}
          </template>
          <template v-slot:cell(actions)="row">
            <b-button @click="deleteGravyItem(row)" variant="danger" size="sm">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </div>
        <div class="row">
            <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination :key="gravies.key" v-model="current_page" :total-rows="gravies.length" :per-page="10"></b-pagination>
                </ul>
            </div>
            </div>
        </div>
    </div>    
    </div>
</template>

<style>
    
</style>